import { CloseOutline } from "@carbon/icons-react";
import React from "react";
import { useTranslation } from "react-i18next";

interface NoExamsProps {
  label?: string | React.ReactNode;
}
export const NoExams = ({ label }: NoExamsProps) => {
  const { t } = useTranslation();

  return (
    <div className="w-full h-[172px] gap-[24px] flex flex-col items-center justify-center bg-white rounded shadow">
      <CloseOutline size={24} className="text-gray-376" />
      {typeof label === "string" ? (
        <p className="text-[16px] leading-[20.16px]">{t(label ?? "")}</p>
      ) : (
        <>{label}</>
      )}
    </div>
  );
};
